import React, { useState } from "react";
import axios from "axios";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CardActions from "@mui/material/CardActions";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import "./App.css";
import StickyFooter from "./components/Footer";

function App() {
  const [username, setUsername] = useState("");
  const [repositories, setRepositories] = useState([]);
  const [sortBy, setSortBy] = useState("stars");

  const handleCopyClick = (repoUrl) => {
    navigator.clipboard.writeText(repoUrl);
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.get(
        `https://api.github.com/users/${username}/repos?sort=${sortBy}`
      );
      setRepositories(response.data);
    } catch (error) {
      console.error(error);
    }
  };
  const handleSortChange = (event) => {
    setSortBy(event.target.value);
  };

  const sortRepositories = (repos) => {
    return repos.sort((a, b) => b[sortBy] - a[sortBy]);
  };
  const sortedRepositories = sortRepositories(repositories);

  return (
    <div>
      <div className="headding">
        <h1>GitHub Explorer</h1>
        <FormControl>
          <form className="mt-4" onSubmit={handleSearch}>
            <div className="input-group mb-3">
              <TextField
                type="text"
                id="outlined-basic"
                label="username"
                className="form-control"
                placeholder="Enter GitHub username"
                variant="outlined"
                size="small"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className="btn">
              <Button variant="outlined" type="submit">
                Search
              </Button>
            </div>
            <div className="form-check">
              <RadioGroup
                aria-label="sort"
                name="sort"
                value={sortBy}
                sx={{
                  padding: "10px",
                }}
                row
              >
                <FormControlLabel
                  value="stargazers_count"
                  control={<Radio />}
                  label="Sort by Stars"
                  onChange={handleSortChange}
                />
                <FormControlLabel
                  value="forks"
                  control={<Radio />}
                  label="Sort by Forks"
                  onChange={handleSortChange}
                />
              </RadioGroup>
            </div>
          </form>
        </FormControl>
      </div>
      {/* <hr /> */}
      {/* <h3>Repositories:</h3> */}
      <div className="container-fluid">
        {" "}
        <Box>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {sortedRepositories.map((repo) => (
              <Grid item key={repo.id} sx={{ marginBottom: "40px" }}>
                <Card
                  sx={{
                    backgroundColor: "rgba(0, 0, 0, 0.38)",
                    width: 400,
                    height: 150,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
                    transition: "all 0.3s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.05)",
                      boxShadow: "0 0 20px rgba(0, 0, 0, 0.2)",
                    },
                    mb: "20px",
                    marginLeft: "20px",
                    borderRadius: 4,
                    p: 3,
                  }}
                >
                  <CardContent
                    sx={{
                      textAlign: "left",
                    }}
                  >
                    <Typography gutterBottom variant="h5" component="div">
                      {repo.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ display: "inline-block" }}
                    >
                      <span className="badge bg-primary">
                        Forks: {repo.forks}
                      </span>
                      &nbsp;
                      <span className="badge bg-secondary">
                        Stars: {repo.stargazers_count}
                      </span>
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {repo.description
                        ? repo.description.slice(0, 50) + "..."
                        : ""}
                    </Typography>
                  </CardContent>
                  <CardActions
                    sx={{
                      ml: "auto",
                    }}
                  >
                    <Button
                      size="small"
                      target="_blank"
                      href={repo.html_url}
                      startIcon={<OpenInNewIcon />}
                    />
                    <Button
                      size="small"
                      value={repo.clone_url}
                      onClick={() => {
                        navigator.clipboard.writeText(repo.clone_url);
                        handleCopyClick(repo.clone_url);
                      }}
                      startIcon={<ContentCopyIcon />}
                    />
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </div>

      <StickyFooter />
    </div>
  );
}

export default App;
